// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"team-m__wrapper__WJfNw","header-wrapper":"team-m__header-wrapper__1-y83","load-more":"team-m__load-more__1Pmex"};